import { render, staticRenderFns } from "./RFQCardBody.vue?vue&type=template&id=1deebadc&"
import script from "./RFQCardBody.vue?vue&type=script&lang=js&"
export * from "./RFQCardBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports